import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import Details from "./DetailsVariant";
import { betsSlipAdd, betsSlipToggle, betsSlipClear } from "../../store/actions/betsSlip";
import { getBetsState } from "../../store/selectors/betData";
import { formatOddValue, formatTicketBetTitle } from "../../utils/formatters";
import { debug } from "../../utils";

const useStyles = makeStyles({
	ticketRoot: {
		margin: "12px 0 0",
		padding: 1,
		backgroundColor: "#FFFFFF",
		borderRadius: 0
	},
	ticketData: {
		padding: "5px 17px 6px",
		fontSize: 12,
		color: "#17214D",
		fontWeight: 600,
		cursor: "pointer"
	},
	ticketDataItem: {
		flex: "1 1 0",
		whiteSpace: "nowrap",
		textAlign: "left",
		fontSize: 16,
		color: "#797A7C",
		fontWeight: 600,
	},
	tar: {
		textAlign: "right"
	},
	ticketDetails: {
		padding: "0"
	},
	divider: {
		width: "calc(100% - 13px)",
		margin: "0 auto 17px",
		borderTop: "1px solid #707070",
		height: "0px"
	},
	status: {
		fontSize: "15px",
		fontWeight: "bold",
		textAlign: "center",
		color: "#000",
		padding: "3px 0 4px",
		display: "inline-block",
		whiteSpace: "nowrap"
	},
	won: {
		borderRight: "3px solid #06D2BD",
		color: "#FF196E",
		paddingRight: "10px",
		marginRight: "10px",
		display: "inline-block",
		"& svg": {
			display: "inline-block"
		}
	},
	lost: {
		borderRight: "3px solid #FF196E",
		color: "#FF196E",
		paddingRight: "10px",
		marginRight: "10px",
		display: "inline-block"
	},
	void: {
		borderRight: "3px solid #FF196E",
		color: "#FF196E",
		paddingRight: "10px",
		marginRight: "10px",
		display: "inline-block"
	},
	possibleWin: {
		display: "inline-block",
		marginRight: "10px"
	},
	list: {
		fontSize: "12px"
	},
	columnItem: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		margin: "14px 22px",
		"&:first-child": {
			marginTop: "7px"
		}
	},
	listInColumnItem: {
		display: "flex",
		alignItems: "center",
		alignContent: "center",
		justifyContent: "space-between",
		marginTop: "4px",
		color: "#17214D",
		fontSize: "12px",
		width: "100%"
	},
	listItem: {
		margin: "16px 22px 16px 0",
		paddingLeft: "14px",
		color: "#797A7C",
		fontSize: "15px",
		fontWeight: "600",
		"& .tn": {
			color: "#3B3B3B",
		},
		"& .reg": {
			fontWeight: "normal",
			whiteSpace: "nowrap"
		}
	},
	listItemOPEN: {
		borderLeft: "8px solid #1F83E6",
	},
	listItemLOST: {
		borderLeft: "8px solid #D02F30",
	},
	listItemWON: {
		borderLeft: "8px solid #2FD03F",
	},
	listItemVOID: {
		borderLeft: "8px solid #FFC400",
	},
	st: {
		textDecoration: "line-through",
	},
	link: {
		color: "#17214d",
		textDecoration: "underline",
		fontSize: "12px",
		fontWeight: "600",
		cursor: "pointer",
		textAlign: "right"
	},
	rootFilters: {
		"& .MuiPaper-root": {
			backgroundColor: "#EDF0F0"
		},
		"&.MuiDialog-root": {
			zIndex: "1303!important"
		}
	},
	rightSvg: {
		height: "14px",
		width: "auto",
		fill: "#7f7f7f",
		display: "inline-block",
		verticalAlign: "middle",
		float: "right",
		position: "relative",
		top: "2px"
	},
	date: {
		borderRadius: "5px",
		backgroundColor: "#747DA7",
		fontSize: "9px",
		fontWeight: "600",
		color: "#fff",
		padding: "2px 8px",
		display: "inline-block"
	},
	fixed: {
		display: "inline-block",
		textTransform: "uppercase",
		fontSize: "9px",
		fontWeight: "600",
		marginLeft: "5px",
		backgroundColor: "#B7CDD8",
		padding: "2px 8px",
		color: "#fff",
		borderRadius: "5px"
	},
	dateOpen: {
		backgroundColor: "#313F80"
	},
	lostColor: {
		color: "#FF196E"
	},
	wonColor: {
		color: "#06D2BD"
	},
	bigButton: {
		alignSelf: "stretch",
		width: "45%",
		padding: "6px 8px",
		borderRadius: 0,
		fontSize: 14,
		color: "#FFFFFF",
		height: "42px"
	},
	recoverButton: {
		background: "linear-gradient(270deg, #1F83E6 0%, #06D2BD 100%)",
		width: "100%"
	},
	subText: {
		fontSize: "9px",
		fontWeight: "600",
		color: "#979DAB",
		maxWidth: "150px",
		marginTop: "2px",
		marginLeft: "10px"
	},
	ticketHash: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		marginBottom: "10px",
		"& .th-type": {
			flexGrow: 1,
			width: "100%",
			color: "#17214d",
			fontSize: "13px",
			fontWeight: "600",
			textAlign: "right",
			paddingRight: "5px"
		},
		"& .th-hash": {
			flexGrow: 1,
			width: "100%",
			color: "#17214d",
			fontSize: "15px",
			fontWeight: "bold",
			paddingLeft: "5px"
		}
	},
	minHeight: {
		"& .MuiPaper-root.MuiDialog-paper": {
			minHeight: "calc(100vh - 64px)",
			width: "612px"
		}
	},
	subTitle: {
		color: "#292C33",
		fontSize: "12px",
		fontWeight: "normal",
		marginBottom: "5px"
	},
	cp: {
		color: "#B4B4B4",
	},
	pr18: {
		paddingRight: "18px"
	},
	header: {
		height: "34px",
		fontSize: "14px",
		fontWeight: "600",
		textTransform: "uppercase",
		display: "flex",
		width: "100%",
		"&>.first": {
			minWidth: "0",
			width: "100%",
			height: "34px",
			lineHeight: "34px",
			padding: "0 20px"
		},
		"&>.second": {
			cursor: "pointer",
			minWidth: "45px",
			maxWidth: "45px",
			width: "45px",
			height: "34px",
			lineHeight: "34px",
			textAlign: "center",
			background: "rgba(255,255,255,.2)",
			"& svg": {
				fontSize: "2em"
			}
		}
	},
	headerOPEN: {
		backgroundColor: "#7E7D80",
		color: "#E8E8E8",
	},
	headerLOST: {
		backgroundColor: "#845858",
		color: "#E8E8E8",
	},
	headerWON: {
		backgroundColor: "#008A41",
		color: "#E8E8E8",
	},
	statusTextOPEN: {
		color: "#797A7C",
		fontSize: "16px",
		fontWeight: "600",
		textTransform: "uppercase",
	},
	statusTextLOST: {
		color: "#D02F30",
		fontSize: "16px",
		fontWeight: "600",
		textTransform: "uppercase",
	},
	statusTextWON: {
		color: "#2FD03F",
		fontSize: "16px",
		fontWeight: "600",
		textTransform: "uppercase",
	},
	close: {
		height: "42px",
		cursor: "pointer",
		color: "#0C3594",
		border: "1px solid #0C3594",
		borderRadius: "2px",
		margin: "0 13px 20px 13px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& svg": {
			fontSize: "2.5em"
		}
	}
});

const formatDate = dt => {
	const d = moment(dt);
	return d.format("DD/MM/YYYY HH:mm");
};

const Collapsed = ({ ticket, matches, addBet, toggleBet, clearBets, t }) => {
	const classes = useStyles();

	const [extended, setExtended] = React.useState(false);

	const type = ticket.type;

	let typeText = null;
	if (ticket.status === "OPEN") {
		typeText = <span className={classes.statusTextOPEN}>{t("Opened")}</span>;
	} else if (ticket.status === "LOST") {
		typeText = <span className={classes.statusTextLOST}>{t("Lost")}</span>;
	} else if (ticket.status === "WON") {
		typeText = <span className={classes.statusTextWON}>{t("Won")}</span>;
	}

	const handleExtended = () => {
		setExtended(true);
	};

	const toggleExtended = () => {
		setExtended(v => !v);
	};

	let canRecover = false;
	let hasLostBets = false;
	let hasOpenBets = false;

	ticket.bets.forEach(tb => {
		if (tb.status === "LOST") {
			hasLostBets = true;
			return;
		}

		if (tb.status !== "OPEN") {
			return;
		}

		if (!(tb.idMatch in matches)) {
			return;
		}

		hasOpenBets = true;
	});

	canRecover = hasLostBets && hasOpenBets;

	const recoverTicket = () => {
		debug("recover", ticket);

		let slipCleared = false;

		ticket.bets.forEach(tb => {
			if (tb.status !== "OPEN") {
				//console.log("bet is no longer open", tb);
				return;
			}

			if (!(tb.idMatch in matches)) {
				debug("match is no longer in state", tb.idMatch, matches);
				return;
			}

			debug(
				"recover bet",
				ticket.format,
				tb.idSport,
				tb.idMatch,
				tb.idBet,
				tb.idMatchBet,
				tb.idBetOutcome,
				tb.idMatchBetOutcome
			);

			if (!slipCleared) {
				slipCleared = true;
				clearBets();
			}

			toggleBet(
				ticket.format,
				tb.idSport,
				tb.idMatch,
				tb.idBet,
				tb.idMatchBet,
				tb.idBetOutcome,
				tb.idMatchBetOutcome
			);
		});
	};

	let free_bet_name = null;

	if (ticket && ticket.clientVal && typeof ticket.clientVal.free_bet_code !== "undefined") {
		free_bet_name = <span className={classes.cp}>
			&nbsp;|&nbsp;FREE BET
		</span>;
	}

	const teamNames = (teams) => {
		const teamNames = [];
		teams && teams.forEach(team => {
			teamNames.push(team.teamDisplayName);
		});
		return teamNames.join(" : ");
	};

	const pBets = ticket.bets.filter(b => b.mType === "prematch").length;
	const lBets = ticket.bets.filter(b => b.mType === "live").length;

	let product = "Combo";
	if (pBets === 0) {
		product = "Live";
	} else if (lBets === 0) {
		product = "Prematch";
	}

	return (
		<div className={classes.ticketRoot}>
			<div className={`${classes.header} ${classes[`header${ticket.status}`]}`} onClick={toggleExtended}>
				<div className="first">{t("Ticket Details")}</div>
				<div className="second">
					<div>
						{extended && <ExpandLessIcon />}
						{!extended && <ExpandMoreIcon />}
					</div>
				</div>
			</div>
			<div className={classes.ticketData}>
				<div className="d-flex flex-nowrap align-items-center">
					<div className={classes.ticketDataItem}>
						{product} {type} {typeText !== null ? "|" : ""} {typeText}
					</div>
				</div>
				<div className="d-flex flex-nowrap align-items-center justify-content-between">
					<div className={classes.subTitle}>
						{ticket.idHash}
						<span className={classes.cp}>
							&nbsp;|&nbsp;{moment(ticket.createdAt).format("DD/MM/YYYY HH:mm")}
						</span>
						{free_bet_name}
					</div>
				</div>
			</div>
			<div className={classes.divider}></div>
			<div className={classes.list}>
				{ticket.bets.map((bet, i) => {
					if (!extended && i > 1) {
						return null;
					}

					let outcome = bet.outcomeDisplayName;
					if (bet.status === "VOID") {
						outcome = (<React.Fragment>
							{bet.outcomeDisplayName}
						</React.Fragment>)
					}

					let betStatus = bet.status;
					const betStatusCls =
						betStatus === "WON"
							? classes.listItemWON
							: betStatus === "LOST"
								? classes.listItemLOST
								: betStatus === "VOID"
									? classes.listItemVOID
									: classes.listItemOPEN;

					let oddValue = formatOddValue(bet.oddValue);
					if (bet.status === "VOID") {
						oddValue = (<React.Fragment>
							<span className={classes.st}>{oddValue}</span> 1.00
						</React.Fragment>);
					}

					return (
						<div key={i} className={`${classes.listItem}  ${betStatusCls}`}>
							<div className="d-flex flex-nowrap align-items-start justify-content-between">
								<div className={"tn"}>
									{teamNames(bet.teams)}
								</div>
								<div className={"reg"}>
									{formatDate(bet.startAt)}
								</div>
							</div>
							<div className="d-flex flex-nowrap align-items-end justify-content-between">
								<div>
									{formatTicketBetTitle(bet)} | {outcome}
								</div>
								<div>
									{oddValue}
								</div>
							</div>
						</div>
					);
				})}
				{!extended && (
					<div className={`${classes.listItem} ${classes.link}`} onClick={handleExtended}>
						{ticket.bets.length <= 2 && <span>{t("See details")}</span>}
						{ticket.bets.length > 2 && (
							<span>
								+{ticket.bets.length - 2} {t("bets")}...
							</span>
						)}
					</div>
				)}
			</div>
			{extended && (
				<React.Fragment>
					<div className={classes.ticketDetails}>
						<Details ticket={ticket} />
					</div>
					<div
						className={`${classes.listItem} d-flex flex-row align-items-start justify-content-between`}
					>
						{ticket.format !== "prematch-reserved" && ticket.format !== "live-reserved" && (
							<React.Fragment>
								{canRecover && <div>&nbsp;</div>}
								{canRecover && (
									<div>
										<div>
											<Button
												onClick={recoverTicket}
												className={`${classes.bigButton} ${classes.recoverButton}`}
											>
												{t("Recover")}
											</Button>
											<div className={classes.subText}>
												*{t("Place the same ticket without losing matches")}
											</div>
										</div>
									</div>
								)}
							</React.Fragment>
						)}
						{(ticket.format === "prematch-reserved" ||
							ticket.format === "live-reserved") && (
								<React.Fragment>
									{ticket.ticketHashes.map((h, i) => (
										<div key={i} className={classes.ticketHash}>
											<div className="th-type">{h.type}</div>
											<div className="th-hash">{h.hash}</div>
										</div>
									))}
								</React.Fragment>
							)}
					</div>
					<div className={classes.close} onClick={toggleExtended}>
						<ExpandLessIcon />
					</div>
				</React.Fragment>
			)}
		</div>
	);
};

const mapStateToProps = (state, props) => {
	const bst = getBetsState(state);

	let matches = [];
	if (
		props.ticket &&
		(props.ticket.format === "prematch" || props.ticket.format === "live") &&
		bst[props.ticket.format] &&
		bst[props.ticket.format].matches) {
		matches = bst[props.ticket.format].matches;
	}

	return {
		matches
	};
};

const actionCreators = {
	addBet: betsSlipAdd,
	toggleBet: betsSlipToggle,
	clearBets: betsSlipClear
};

export default withTranslation()(connect(mapStateToProps, actionCreators)(Collapsed));
